// PRO+ band hub: who may edit (THE WALL signed in, or the band signed in on /musician with its passcode).
import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { API } from "../../App";
import { bandKeyName } from "../musician/PasscodeLogin";

export const NEON = "#54E3FF";

export const hubAuth = () => {
  const headers = {};
  const token = localStorage.getItem("token");
  if (token) headers.Authorization = `Bearer ${token}`;
  const sid = localStorage.getItem("wall_musician_session");
  const key = sid && localStorage.getItem(bandKeyName(sid));
  if (key) { headers["X-Musician-Session"] = sid; headers["X-Band-Key"] = key; }
  return { headers, withCredentials: true };
};

// "admin" | "band" | null
export const useHubEditor = (slug, on) => {
  const [as, setAs] = useState(null);
  useEffect(() => {
    if (!on) { setAs(null); return; }
    axios.get(`${API}/bands/${slug}/hub/editor`, hubAuth()).then((r) => setAs(r.data.can_edit ? r.data.as : null)).catch(() => setAs(null));
  }, [slug, on]);
  return as;
};

// Editors see every photo (hidden ones too); everyone else sees the page's visible photos.
export const useHubPhotos = (slug, editor, publicPhotos) => {
  const [all, setAll] = useState(null);
  const load = useCallback(() => {
    if (!editor) { setAll(null); return; }
    axios.get(`${API}/bands/${slug}/hub/photos`, hubAuth()).then((r) => setAll(r.data || [])).catch(() => setAll(null));
  }, [slug, editor]);
  useEffect(() => { load(); }, [load]);
  return [all || publicPhotos, load];
};

export const ytId = (u = "") => (u.match(/(?:v=|youtu\.be\/|embed\/|shorts\/|live\/)([\w-]{6,})/) || [])[1];
